import React from 'react';
import { FaEye, FaBullseye, FaHeart } from 'react-icons/fa';
import '../styles/About.css';

const AboutMissionVision = ({ language }) => {
  return (
    <section className="py-5 bg-white" id="mission-vision">
      <div className="container">
<h2 className="text-center fw-bold mb-5" style={{ color: '#1e3a8a' }}>
  {language === 'en' 
    ? 'Our Vision, Mission & Our Values' 
    : 'የእኛ ራዕይ፣ ተልእኮ እና መሠረታዊ እሴቶች'}
</h2>
        <div className="row text-center" data-aos="fade-up">

          <div className="col-md-4 mb-4">
            <FaEye size={40} className="icon-vision mb-3" />
            <h5 className="fw-bold" style={{ color: '#1e3a8a' }}>
      {language === 'en' ? 'Vision' : 'ራዕይ'}
    </h5>
    <p>
      {language === 'en' 
        ? 'To be Addis Ababa’s preferred destination for warm hospitality, refined comfort, and memorable experiences.'
        : 'በአዲስ አበባ ለሙቀት ያለ አቀባበል፣ ለጥራት ያለ ምቾት እና ለማይረሱ ልምዶች ተመራጭ መዳረሻ መሆን።'
      }
    </p>

          </div>

          <div className="col-md-4 mb-4">
            <FaBullseye size={40} className="icon-mission mb-3" />
           <h5 className="fw-bold" style={{ color: '#1e3a8a' }}>
      {language === 'en' ? 'Mission' : 'ተልእኮ'}
    </h5>
    <p>
      {language === 'en' 
        ? 'To deliver exceptional stays, delightful dining, and versatile venues—supported by attentive, personalized service for every guest.'
        : 'ለእያንዳንዱ እንግዳ በጥንቃቄ እና በግል አቀባበል የሚደገፍ በጣም ጥሩ መኖሪያ፣ ደስ የሚል ምግብ እና በተለያዩ ዝግጅቶች ለሚስሩ አዳራሾችን ማቅረብ ነው።'
      }
    </p>
    
          </div>

<div className="col-md-4 mb-4 text-center">
  <FaHeart size={40} className="icon-values mb-3" />
  <h5 className="fw-bold" style={{ color: '#1e3a8a' }}>
    {language === 'en' ? 'Core Values' : 'መሠረታዊ እሴቶች'}
  </h5>
  <div className="d-flex flex-column align-items-center mt-3">
    {(language === 'en'
      ? [
          'Integrity',
          'Excellence',
          'Strong corporate identity and reputation',
          'Customer satisfaction',
          'Employee empowerment and teamwork',
        ]
      : [
          'ታማኝነት',
          'የላቀ አገልግሎት',
          'ጠንካራ ድርጅታዊ ማንነትና ስም',
          'የደንበኛ እርካታር',
          'የቡድን ስራ እና የሰራተኞችን አቅም ማሳደግ ዋና ዋናዎቹ ናቸው።',
        ]
    ).map((item, index) => (
      <div key={index} className="d-flex align-items-start mb-2">
        <span className="me-2">👉</span>
        <span>{item}</span>
      </div>
    ))}
  </div>
</div>

        </div>
      </div>
    </section>
  );
};

export default AboutMissionVision;

